import React from 'react'
import ReactDOM from 'react-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'
import App from 'components/App'
import theme from './themes/main'
import { Provider } from 'react-redux'
import store from 'store'
import { BrowserRouter } from 'react-router-dom'
// var viewportUnitsBuggyfill = require('viewport-units-buggyfill')

// viewportUnitsBuggyfill.init({ force: true })

import './styles/base.css'
import 'react-phone-input-mui/dist/style.css'
import 'react-phone-number-input/style.css'
import '@brainhubeu/react-carousel/lib/style.css'

const isMobile = window.innerWidth <= 800
const isIos =
  navigator.platform && /iPad|iPhone|iPod|Mac/.test(navigator.platform)
const isIphone = isIos && /iPhone/.test(navigator.platform)

window.isMobile = isMobile
window.isIos = isIos
window.isIphone = isIphone

// to fix persist state only working if item is already in local storage
if (!localStorage.getItem('EVENT-GIVES-LIVE')) {
  localStorage.setItem(
    'EVENT-GIVES-LIVE',
    JSON.stringify({
      authentication: {
        authenticatedUser: {},
        location: {},
        loggingIn: false,
        loginError: false,
        registerError: false,
        registering: false,
        token: ''
      }
    })
  )
  window.location.reload()
}

const initializeCastApi = function() {
  window.cast.framework.CastContext.getInstance().setOptions({
    receiverApplicationId:
      window.chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
    autoJoinPolicy: window.chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED
  })
}

window['__onGCastApiAvailable'] = function(isAvailable) {
  if (isAvailable) {
    initializeCastApi()
    console.log('Google Chrome Cast SDK initialized')
  }
}

const Application = (
  <Provider store={store}>
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </MuiThemeProvider>
    </BrowserRouter>
  </Provider>
)
setTimeout(() => {
  ReactDOM.render(Application, document.getElementById('root'))
}, 500)



// WEBPACK FOOTER //
// ./src/index.js